import {ProductCategoryModel} from "./products.model";
import AppStore from "../../app.store";
import axios, { GenericAbortSignal } from "axios";
import {api} from "../../api/endpoints";
import {makeAutoObservable} from "mobx";
import {SELECT_PAGE_LIMIT} from "../../utils/pagination";

class ProductCategoriesStore {
    public productCategories ?: ProductCategoryModel[] = [];

    public productCategoriesInit = (signal: GenericAbortSignal, pageLimit = SELECT_PAGE_LIMIT) => {
        void this.productCategoriesReq(signal, pageLimit);
    }

    constructor() {
        makeAutoObservable(this);
    }

    setProductCategories(data: any) {
        const {categories} = data;
        this.productCategories = categories;
    }

    /** Гарантирует, что выбранная категория есть в options (иначе Ant Select показывает сырой id). */
    public ensureCategoryPresent = (category: {
        id: number;
        name?: string;
        attribute_template_id?: number;
        description?: string;
        img?: string;
    }) => {
        const id = Number(category?.id);
        if (!id) {
            return;
        }
        const list = this.productCategories ? [...this.productCategories] : [];
        const index = list.findIndex((item) => Number(item.id) === id);
        if (index >= 0) {
            const current = list[index] as ProductCategoryModel;
            list[index] = {
                ...current,
                name: current.name || category.name || current.name,
                attribute_template_id:
                    Number(current.attribute_template_id) ||
                    Number(category.attribute_template_id) ||
                    0,
            };
            this.productCategories = list;
            return;
        }
        this.productCategories = [
            {
                id,
                name: String(category.name || '').trim() || `Категория #${id}`,
                description: category.description || '',
                img: category.img || '',
                attribute_template_id: Number(category.attribute_template_id) || 0,
            },
            ...list,
        ];
    };

    /**
     * Для edit: кладёт category_id товара в справочник.
     * Если имени/template нет — догружает GET /product_category/:id.
     */
    public ensureProductCategoryOption = async (product: {
        category_id?: number;
        category?: string;
        category_attribute_template_id?: number;
    }) => {
        const id = Number(product?.category_id);
        if (!id) {
            return;
        }

        this.ensureCategoryPresent({
            id,
            name: product.category,
            attribute_template_id: Number(product.category_attribute_template_id) || 0,
        });

        const existing = this.productCategories?.find((item) => Number(item.id) === id);
        const needsDetails =
            !existing
            || !String(existing.name || '').trim()
            || existing.name.startsWith('Категория #')
            || !Number(existing.attribute_template_id);

        if (!needsDetails) {
            return;
        }

        try {
            const {getHeaders} = AppStore;
            const response: any = await axios.get(`${api.product_category}/${id}`, {
                headers: getHeaders(),
            });
            const category = response?.data?.category;
            if (category?.id) {
                this.ensureCategoryPresent({
                    id: Number(category.id),
                    name: category.name,
                    attribute_template_id: Number(category.attribute_template_id) || 0,
                    description: category.description,
                    img: category.img,
                });
            }
        } catch {
            // Оставляем то, что уже есть в списке / fallback-имя.
        }
    };

    public productCategoriesReq = async (signal?: GenericAbortSignal, pageLimit = SELECT_PAGE_LIMIT) => {

        try {
            const {getHeaders} = AppStore

            const headers = getHeaders()

            const response: any = await axios.get(api.product_categories + `?page=1&page_limit=${pageLimit}`, { headers, signal });

            this.setProductCategories(response.data)
        } catch (err) {
        }
    }
}

export default new ProductCategoriesStore();